import { createSystemEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IMunicipality } from "../../utils/types/models";

export default createSystemEntityReducer<IMunicipality>(Endpoint.Municipalities);
